import React from 'react';
import WixImage from './wixImage.js';
import { validate, mergeStyles } from 'wix-rich-content-common';
import pluginImageSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-image.schema.json';
import { s as styles } from './image-viewer.rtlignore-89245fef.js';
import 'classnames';
import './types.js';
import 'lodash';
import '@wix/image';
import './consts.js';
import 'ricos-schema';
import './icons/expand.js';
import './InPluginInput.js';
import './style-inject.es-746bb8ed.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ImageViewer = (props) => {
  React.useEffect(() => {
    validate(props.componentData, pluginImageSchema);
  }, [props.componentData]);
  const mergedStyles = mergeStyles({ styles, theme: props.theme });
  const hasLink = () => {
    var _a, _b, _c;
    return (_c = (_b = (_a = props.componentData) == null ? void 0 : _a.config) == null ? void 0 : _b.link) == null ? void 0 : _c.url;
  };
  const hasExpandMode = () => {
    var _a;
    return !((_a = props.componentData) == null ? void 0 : _a.disableExpand);
  };
  const accessibilityProps = hasLink() || hasExpandMode() ? { role: "button", tabIndex: 0 } : {};
  return /* @__PURE__ */ React.createElement(WixImage, __spreadProps(__spreadValues({}, props), { styles: mergedStyles, accessibilityProps }));
};

export { ImageViewer as default };
//# sourceMappingURL=image-viewer.js.map
